import { Popover } from 'antd';
import InfoIcon from 'components/atoms/icons/infoIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

interface IPopoverLabelProps {
  label: React.ReactNode;
}

export const PopoverLabel: React.FC<IPopoverLabelProps> = ({ label }) => {
  const { t } = useTranslation();

  return (
    <div className={s['item-wrapper']}>
      {label}
      <Popover
        trigger="hover"
        placement="bottomRight"
        arrow={false}
        zIndex={9999}
        content={
          <p className={s['content-wrapper']}>
            {t('smsSubscription.twilioDisableMessage')}
          </p>
        }
      >
        <div style={{ pointerEvents: 'all' }}>
          <InfoIcon />
        </div>
      </Popover>
    </div>
  );
};
